import script from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=d4d45c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4d45c62"]])

export default __exports__